(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["slideshow-controls"] && !Shopify.designMode) return;
  try {
    // Badeloft M3 — keep the two-row (silo / lifestyle) thumbnail strip's
  // selected highlight in sync. The grouped strip reorders thumbnails out of
  // slide order, so the slideshow component's positional aria-selected logic
  // can't be used (track_ref is off for these buttons). Instead we listen for
  // the bubbling slideshow:select event and match by data-slide-index.
  // Delegated on document so it survives variant morphs.
  (function () {
    document.addEventListener('slideshow:select', function (event) {
      var slideshow = event.target;
      if (!slideshow || typeof slideshow.querySelector !== 'function') return;
      var container = slideshow.querySelector('.slideshow-controls__thumbnails-container--grouped');
      if (!container) return;
      var index = event.detail && event.detail.index;
      if (typeof index !== 'number') return;

      var buttons = container.querySelectorAll('.slideshow-controls__thumbnail[data-slide-index]');
      buttons.forEach(function (btn) {
        var match = String(btn.getAttribute('data-slide-index')) === String(index);
        btn.setAttribute('aria-selected', match ? 'true' : 'false');
        if (!match) return;

        var row = btn.parentElement;
        if (!row || row.scrollWidth <= row.clientWidth + 1) return;
        var rowRect = row.getBoundingClientRect();
        var btnRect = btn.getBoundingClientRect();
        var target = row.scrollLeft + (btnRect.left - rowRect.left) - (row.clientWidth - btnRect.width) / 2;
        row.scrollTo({ left: Math.max(0, target), behavior: 'smooth' });
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
